module.exports = __webpack_public_path__ + "static/img/1.e71fb43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/1.png
// module id = d2Jz
// module chunks = 1